// extracted by mini-css-extract-plugin
export default {"root":"IconWifi_root__1upTS"};